import React, { useState, useEffect, useContext } from 'react';
import FormModal from './formmodal';
import {
  getFolders_Name_API,
  get_Skill_Ques_API,getSkilltypeApi
} from '../../api/endpoints';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {
  TestTypeContext,
  QuestionTypeContext,
  SkillTypeContext,
  TestTypeCategoriesContext,
} from '../test/context/testtypecontext';
const LMSAccess = (username) => {
  const [showAddTest, setShowAddTest] = useState(false);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedQuestionPaper, setSelectedQuestionPaper] = useState([]);
  const [showQuestionPaper, setShowQuestionPaper] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [showQuestions, setShowQuestions] = useState(false);
  const [questionPaperPass, setQuestionPaperPass] = useState(null);
  const [questionIdPass, setQuestionsIdPass] = useState(null);

  const { selectedTestType, setSelectedTestType } = useContext(TestTypeContext);
  const { selectedQuestionType, setSelectedQuestionType } = useContext(QuestionTypeContext);
  const { selectedSkillType, setSelectedSkillType } = useContext(SkillTypeContext);
  const { selectedTestTypeCategory } = useContext(TestTypeCategoriesContext);

  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedSubTopic, setSelectedSubTopic] = useState(null);




  // Handle button click when no folders are available
  const handleNoFolderClick = () => {
    setSelectedFolder(null); // No folder selected
    setShowAddTest(true); // Show the TestaccessForm
    setQuestionPaperPass(null);
    setQuestionsIdPass(null);
  };

  const handleNextButtonClick = () => {
    setShowAddTest(false); // Hide Add Test container
    setSelectedFolder(null); // Reset the selected folder
    setQuestions([]);
    setShowQuestionPaper(false);
    setShowDefaultfolder(true)
  };




  const [selectedDefaultFolder, setSelectedDefaultFolder] = useState(null);
  const [selectedSubFolder, setSelectedSubFolder] = useState(null);
  const [showFolderNames, setShowfolderNames] = useState(false);
  const [showDefaultFolder, setShowDefaultfolder] = useState(true);
  const [showSubFolderFolder, setShowSubfolder] = useState(false);
  const [isDefaultFolderClicked, setIsDefaultFolderClicked] = useState(false);




  const [defaultFolders, setDefaultFolders] = useState([]);
  const [subfolders, setSubFolders] = useState([]);

  const questionTypeIcons = {
    Aptitude: "fa-brain",
    Softskills: "fa-user-friends",
    Technical: "fa-laptop-code",
    Communication: "fa-comments",
    Psychometry: "fa-flask",
    CompanySpecific: "fa-building",
  };

  useEffect(() => {
    // console.log('get ques skill useEffect running....');
    // console.log('show add test: ', showAddTest);
    // console.log('show defauld question ....', showDefaultFolder);
    get_Skill_Ques_API().then((data) => {
      setSubFolders(data); // Full response like { Technical: [skills], Aptitude: [skills], ... }

      // Convert keys to folder array with icons
      const foldersWithIcons = Object.keys(data).map((type) => ({
        name: type,
        icon: questionTypeIcons[type] || "fa-folder", // fallback icon
      }));

      setDefaultFolders(foldersWithIcons);
    });




    get_Skill_Ques_API().then((data) => {
      setSubFolders(data); // Save raw data for fallback or debugging

      // Mapping icons (add more as needed)
      const skillIcons = {
        "All Languages": "fa-laptop-code",
        Python: "fa-python",
        C: "fa-code",
        "C++": "fa-cogs",
        JAVA: "fa-coffee",
        Quants: "fa-calculator",
        Logical: "fa-brain",
        Verbal: "fa-comment",
        Overall: "fa-chart-bar",
        Generic: "fa-list",
        Communication: "fa-comments",
        Leadership: "fa-user-tie",
        Teamwork: "fa-users",
        Nonverbal: "fa-user-secret",
        Written: "fa-pen",
        Interpersonal: "fa-handshake",
        Personality: "fa-user",
        Behavior: "fa-theater-masks",
        Emotions: "fa-smile",
        Assessment: "fa-check-circle",
        ProblemSolving: "fa-lightbulb",
        TimeManagement: "fa-clock",
        Teamwork: "fa-users",
        ML: "fa-robot",
        IOT: " fa-network-wired",
        "Data Structures": "fa-database",
      };

      // Transform subfolders like subfoldersOLD
      const transformed = {};
      for (const [questionType, skills] of Object.entries(data)) {
        transformed[questionType] = skills.map((skill) => ({
          name: skill,
          icon: skillIcons[skill] || "fa-circle", // default icon if not matched
        }));
      }

      setSubFolders(transformed);
    });
  }, []);



  // Filter folders based on selectedTestType
 // const filteredFolders =
 //   selectedTestType === "MCQ Test"
 //     ? defaultFolders
 //     : selectedTestType === "Coding Test"
 //       ? defaultFolders.filter((folder) => folder.name === "Technical")
 //       : [];

        
  // Filter folders based on selectedTestType
  const filteredFolders = defaultFolders

  const handleDefaultFolderClick = async (folder) => {
    console.log('defailt folder name: ', folder);

    if (folder === 'Aptitude' || folder === 'Technical' || folder === 'Communication' || folder === 'Psychometry' || folder === 'CompanySpecific') {
      setShowDefaultfolder(false);
      setShowSubfolder(true);
    }

    setSelectedDefaultFolder(folder); // Toggling logic
    setSelectedQuestionType(folder);
    setShowQuestionPaper(false); // Reset show state for the next folder click
    setQuestions([]);
    if (folder === 'Softskills') {
      try {
        setSelectedDefaultFolder(folder);
        const topic = folder;
        const subtopic = '';
        setSelectedTopic(topic);
        setSelectedSubTopic(subtopic);

        setSelectedQuestionType(topic);
        setSelectedSkillType(subtopic);

        setShowDefaultfolder(false);

        setShowAddTest(true); // Show the TestaccessForm

      } catch (error) {
        console.error("Error fetching folder names:", error);
      }
    }
  };


  const handleSubFolderClick = async (folder) => {
    console.log('sub folder name: ', folder);
    setSelectedSubFolder(folder);
    // setShowfolderNames(true);
    setShowSubfolder(false);
    setIsDefaultFolderClicked(false);


    try {
      const topic = selectedDefaultFolder;
      const subtopic = selectedDefaultFolder === "Softskills" ? "" : folder;

      setSelectedTopic(topic);
      setSelectedSubTopic(subtopic);

      setSelectedQuestionType(topic);
      setSelectedSkillType(subtopic);

      console.log("Selected Default Folder:", selectedDefaultFolder);
      console.log("Folder clicked:", folder);

      setShowAddTest(true);

    } catch (error) {
      console.error("Error fetching folder names:", error);
    }
  };


  return (
    <div className='form-ques-testaccess' style={{marginTop:"30px"}}>
      <div>
        {showAddTest && (
          <div>
            <FormModal
              onNextButtonClick={handleNextButtonClick} // Pass the function reference, not the invocation 
              username={username}
            />
            <br />
            <br />
          </div>
        )}

        {!showAddTest && showDefaultFolder && (
          <div className="folder-grid">
            {filteredFolders.map((folder) => (
              <div
                key={folder.name}
                className="folder-item"
                onClick={() => handleDefaultFolderClick(folder.name)}
              >
                <i className={`folder-icon fas ${folder.icon}`}></i>
                <p className="folder-name">{folder.name}</p>
              </div>
            ))}
          </div>
        )}

        {!showAddTest && selectedDefaultFolder && showSubFolderFolder && (
          <div className="subfolder-container">
            <div className="subfolder-grid">
              {subfolders[selectedDefaultFolder] &&
                subfolders[selectedDefaultFolder].map((subfolder, index) => (
                  <div
                    key={typeof subfolder === "object" ? subfolder.name : subfolder}
                    className="subfolder-item"
                    onClick={() =>
                      handleSubFolderClick(
                        typeof subfolder === "object" ? subfolder.name : subfolder
                      )
                    }
                  >
                    {typeof subfolder === "object" ? (
                      <>
                        <i className={`subfolder-icon fas ${subfolder.icon}`}></i>
                        <p className="subfolder-name">{subfolder.name}</p>
                      </>
                    ) : (
                      <p className="subfolder-name">{subfolder}</p>
                    )}
                  </div>
                ))}
            </div>
          </div>
        )}


      </div>
    </div>
  );
};

export default LMSAccess;
